import React, { useState } from "react";
import { useData } from "../../../context/DataContext";
import ImageUploadField from "../../../utils/ImageUploadField";
import { confirmDelete, successToast, errorToast } from "../../../utils/dialog";

const TeamPhotosAdmin = () => {
  const { teamPhotos, addTeamPhoto, deleteTeamPhoto } = useData();
  const [imageFile, setImageFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
    }
  };

  const handleAddPhoto = async () => {
    if (!imageFile) {
      errorToast("Please select an image to upload.");
      return;
    }

    try {
      await addTeamPhoto(imageFile);
      successToast("Team photo added.");
      setImageFile(null);
    } catch (err) {
      console.error(err);
      errorToast("Error adding team photo.");
    }
  };

  const handleDeletePhoto = async (id) => {
    if (
      await confirmDelete({
        title: "Delete photo?",
        text: "This team photo will be permanently removed.",
      })
    ) {
      try {
        await deleteTeamPhoto(id);
        successToast("Team photo deleted.");
      } catch (err) {
        console.error(err);
        errorToast("Error deleting team photo.");
      }
    }
  };

  return (
    <div className="p-6 space-y-8">
      <h2 className="text-3xl font-bold mb-4 text-gray-800">Team Photos Admin Panel</h2>

      {/* Add Photo */}
      <div className="bg-white p-6 rounded-lg shadow space-y-4">
        <h3 className="text-2xl font-semibold text-gray-700 mb-4">Add Team Photo</h3>
        <ImageUploadField
          label="Photo"
          hint="Recommended size: 300×300px (square)"
          aspect="square"
          file={imageFile}
          onChange={handleFileChange}
          onClear={() => setImageFile(null)}
        />
        <button
          onClick={handleAddPhoto}
          className="px-6 py-2 bg-[#14251F] hover:bg-[#1f3a30] text-[#FFD1A0] rounded transition font-medium"
        >
          Upload Photo
        </button>
      </div>

      {/* Existing Photos */}
      <div className="bg-white p-6 rounded-lg shadow space-y-4">
        <h3 className="text-2xl font-semibold text-gray-700 mb-4">Existing Team Photos</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {teamPhotos.map((photo) => (
            <div key={photo.id} className="border rounded p-4 shadow">
              <img
                src={photo.imageUrl || "https://via.placeholder.com/150"}
                alt="Team Photo"
                className="w-full h-40 object-cover rounded mb-4"
              />
              <button
                onClick={() => handleDeletePhoto(photo.id)}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              >
                Delete
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TeamPhotosAdmin;